import { render } from "./AddModalIncoterm.vue?vue&type=template&id=5f5ee16d&ts=true"
import script from "./AddModalIncoterm.vue?vue&type=script&lang=ts"
export * from "./AddModalIncoterm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__